/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ShadowSubsystemActionOneOf } from './ShadowSubsystemActionOneOf';
import {
    instanceOfShadowSubsystemActionOneOf,
    ShadowSubsystemActionOneOfFromJSON,
    ShadowSubsystemActionOneOfFromJSONTyped,
    ShadowSubsystemActionOneOfToJSON,
} from './ShadowSubsystemActionOneOf';
import type { ShadowSubsystemActionOneOf1 } from './ShadowSubsystemActionOneOf1';
import {
    instanceOfShadowSubsystemActionOneOf1,
    ShadowSubsystemActionOneOf1FromJSON,
    ShadowSubsystemActionOneOf1FromJSONTyped,
    ShadowSubsystemActionOneOf1ToJSON,
} from './ShadowSubsystemActionOneOf1';

/**
 * @type ShadowSubsystemAction
 * Next-step recommendation attached to a subsystem result.
 * @export
 */
export type ShadowSubsystemAction = ShadowSubsystemActionOneOf | ShadowSubsystemActionOneOf1;

export function ShadowSubsystemActionFromJSON(json: any): ShadowSubsystemAction {
    return ShadowSubsystemActionFromJSONTyped(json, false);
}

export function ShadowSubsystemActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAction {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfShadowSubsystemActionOneOf(json)) {
        return ShadowSubsystemActionOneOfFromJSONTyped(json, true);
    }
    if (instanceOfShadowSubsystemActionOneOf1(json)) {
        return ShadowSubsystemActionOneOf1FromJSONTyped(json, true);
    }
    return {} as any;
}

export function ShadowSubsystemActionToJSON(json: any): any {
    return ShadowSubsystemActionToJSONTyped(json, false);
}

export function ShadowSubsystemActionToJSONTyped(value?: ShadowSubsystemAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfShadowSubsystemActionOneOf(value)) {
        return ShadowSubsystemActionOneOfToJSON(value as ShadowSubsystemActionOneOf);
    }
    if (instanceOfShadowSubsystemActionOneOf1(value)) {
        return ShadowSubsystemActionOneOf1ToJSON(value as ShadowSubsystemActionOneOf1);
    }
    return {};
}

